/// <reference path="../../types.d.ts"" />

import history from '../../history';
import { connect } from 'react-redux';

import { Admin } from './Admin';
import { buildDispatchable } from '../../actions/_action-utilities';
import { changeAdminTab, navigate } from '../../actions/ui';
import { getFeaturesBySection } from '../../actions/organization';
import { CMxComponents } from '@codametrix/ui-components/src/types';
import { loadDictionaries } from '../../actions/dictionary';

const mapStateToProps = function(state: any): AppProps.AdminScreenProps {
  const { organization, ui } = state;
  return {
    ...organization,
    auth: state.login.auth,
    actionGroups: ui.actionGroups,
    adminTabs: ui.AdminTabs,
    serviceLine: ui.serviceLine
  };
};

const mapDispatchToProps = (dispatch: any) => {
  const runDispatchable = buildDispatchable(dispatch);

  return {
    selectTab: (
      navPath: string,
      activeSubAction: CMxComponents.TabDef,
      adminTabs: CMxComponents.TabDef[]
    ) => {
      runDispatchable(() => {
        history.push('/cmx/' + navPath);
        dispatch(navigate(activeSubAction));
        return dispatch(changeAdminTab(adminTabs));
      });
    },
    navigateCaseConfig: (orgId: number) => {
      runDispatchable(() => {
        history.push(`/cmx/admin/orgs/${orgId}/case-config`);
      });
    },
    navigateDictionaries: (org: any) => {
      runDispatchable(() => {
        //@ts-ignore
        return dispatch(loadDictionaries(org));
      });
    },
    navigateGroups: (orgId: number) => {
      runDispatchable(() => {
        //@ts-ignore
        history.push(`/cmx/admin/orgs/${orgId}/groups`);
      });
    },
    navigateFeatures: (section: string, orgId: number) => {
      runDispatchable(() => {
        history.push(`/cmx/admin/orgs/${orgId}/features`);
        return dispatch(getFeaturesBySection(section));
      });
    },
    navigateConfigurations: (orgId: number) => {
      runDispatchable(() => {
        history.push(`/cmx/admin/orgs/${orgId}/configurations`);
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
